export const BOOKS_CREATE               = 'BOOKS_CREATE';
export const BOOKS_CREATE_DONE          = 'BOOKS_CREATE_DONE';

export const BOOKS_FETCH                = 'BOOKS_FETCH';
export const BOOKS_FETCH_DONE           = 'BOOKS_FETCH_DONE';

export const BOOKS_SHOW                 = 'BOOKS_SHOW';

export const BOOKS_FETCH_CATERERS       = 'BOOKS_FETCH_CATERERS';
export const BOOKS_FETCH_CATERERS_DONE  = 'BOOKS_FETCH_CATERERS_DONE';

export const BOOK_FOLLOW                = 'BOOK_FOLLOW';
export const BOOK_FOLLOW_DONE           = 'BOOK_FOLLOW_DONE';

export const BOOK_UNFOLLOW              = 'BOOK_UNFOLLOW';
export const BOOK_UNFOLLOW_DONE         = 'BOOK_UNFOLLOW_DONE';

export const BOOKS_LIST_CLEAR           = 'BOOKS_LIST_CLEAR';
export const BOOKS_SEARCH               = 'BOOKS_SEARCH';



// WEBPACK FOOTER //
// ./app/constants/booksTypes.js